/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// document.querySelector('.sticky-quantity-selector .quantity-selector__input').addEventListener('change', function() {
//     var value = document.querySelector('.sticky-quantity-selector .quantity-selector__input').value * 1;
//     console.log('value', value)

//     document.querySelector('.product__info .quantity-selector__input').value = value;
// });


$(window).on('load',function() {
// Iterate over each .kaching-bundles__bar element and set up an observer
$('.kaching-bundles__bar').each(function() {
  const $targetElement = $(this);

  // Set up the MutationObserver for this specific element
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        $targetElement.hasClass('kaching-bundles__bar--selected')
      ) {
        // Get the price text, remove the "$" symbol, and parse it as a number
        const priceText = $targetElement.find('.kaching-bundles__bar-price').text();
        const priceValue = parseFloat(priceText.replace('$', ''));

        // Find the .product-form parent, then locate #AddToCart .product-button-price
        const $productButtonPriceElement = $targetElement
          .closest('.product-form')
          .find('#AddToCart .product-button-price');
        // Find the nearest .lb-spc-details-checkbox and uncheck it
        const $checkbox = $targetElement.closest('.product-form').find('.lb-spc-details-checkbox');
        if ($checkbox.length) {
          $checkbox.prop('checked', false); // Uncheck the checkbox
        }
        
        if ($productButtonPriceElement.length) {
          $productButtonPriceElement.attr('data-base-price', priceValue);
        }
      }
    });
  });

  // Start observing this element for class attribute changes
  observer.observe($targetElement[0], { attributes: true, attributeFilter: ['class'] });
});

  
console.log("custom js loaded");
  $(document).on('change', '.lb-spc-details-checkbox', function() {
    // Pass the context (closest parent container) to updateTotalPrice
    updateTotalPrice($(this).closest('.product-form__payment-container'));
});

function updateTotalPrice(context) {
    let totalAddonPrice = 0;
    // Find the closest .product-button-price element within the context
    const productButtonPrice = context.find('.product-button-price');
    var basePrice = parseFloat(productButtonPrice.attr('data-base-price'));
    // Loop through each addon element within the provided context
    context.find('.lb-spc-details-checkbox').each(function() {
      const addonCheckBox = $(this);
      const addonPriceElement = $(this).closest('.lb-spc-body').find('.lb-upsell-money-2').first(); // Find price in the same .lb-spc-body

      if (addonCheckBox.is(':checked')) {
        const addonPrice = parseFloat(addonPriceElement.attr('default-price'));
        totalAddonPrice += addonPrice;
      }
    });

    
    
    var newPrice = basePrice + totalAddonPrice;
  
    // Update the displayed price for the closest productButtonPrice element
    productButtonPrice.text(`$${newPrice.toFixed(2)}`);
}


  $('.product-button-price').each(function() {
    let productButtonPrice = $(this);
    let basePrice = parseFloat(productButtonPrice.data('base-price'));
  
    if (typeof productButtonPrice.data('base-price') === 'undefined' || isNaN(basePrice)) {
      let priceText = productButtonPrice.text();
  
      // Remove the currency symbol (either $ or RM)
      let cleanedPrice = priceText.replace(/[$RM]/g, '').trim(); // Removes $ and RM and trims any whitespace
      // Convert cleanedPrice to a number (float)
      basePrice = parseFloat(cleanedPrice);
  
      // Set the cleaned price as the new value of data-base-price attribute
      productButtonPrice.attr('data-base-price', basePrice);  // Use .attr() to update the actual DOM attribute
    }
});


 


  // // Function to clone the StickyAddToCart button as a span and assign a new ID
  // function duplicateStickyAddToCart() {
  //   const originalButton = $('#StickyAddToCart');
    
  //   // Clone the original button, convert it to a span, and assign a new ID
  //   const clonedSpan = $('<span></span>').attr('id', 'NewStickyAddToCart')
  //     .addClass(originalButton.attr('class')) // Copy classes
  //     .html(originalButton.html()); // Copy inner content
    
  //   // Append the new span to the DOM, just after the original button
  //   originalButton.after(clonedSpan);
    
  //   // Hide the original button
  //   originalButton.hide();

  //   // Add click event listener to scroll to the <product-meta> element
  //   $('#NewStickyAddToCart').on('click', function() {
  //     $('html, body').animate({
  //       scrollTop: $('product-meta').offset().top
  //     }, 'slow');
  //   });
  // }

  // // Event listener for the add-on checkbox
  // $('.lb-spc-details-checkbox').on('change', function() {
  //   if ($(window).width() < 750) { // Check if screen width is less than 750px
  //     if ($(this).is(':checked')) {
  //       duplicateStickyAddToCart();
  //     } else {
  //       // If checkbox is unchecked, restore the original button and remove the new span
  //       $('#StickyAddToCart').show();
  //       $('#NewStickyAddToCart').remove();
  //     }
  //   }
  // });



});




$('.sticky-quantity-selector .quantity-selector__input').on('change', function() {
  setTimeout( function() {
    var value = $('.sticky-quantity-selector .quantity-selector__input').val() * 1;
    $('.product__info .quantity-selector__input').val(value);
  },100)
});


$('.sticky-quantity-selector .quantity-selector__button').on('click', function() {
  setTimeout( function() {
    var value = $('.sticky-quantity-selector .quantity-selector__input').val() * 1;
    $('.product__info .quantity-selector__input').val(value);
 },100)
});

// Smooth scroll

jQuery(document).ready(function($){
  // Add smooth scrolling to all links
  $("a").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
});


document.addEventListener('variant:changed', function(event) {
  var price = $('.product-sticky-form__price').html();
  
  var priceHtml = `Add to cart <span class="button-sticky-form__price">${price}</span>`
  $('#StickyAddToCart .loader-button__text').html(priceHtml)
});

if($('.container .page-header .page-header__text-wrapper .heading.h1').text() == "all") {
    $('.container .page-header .page-header__text-wrapper .heading.h1').text('Products')
}

(function() {
  // Peejay added code  - move to live once approved - Cart Messages https://webmedic.app/agent/view/gzl2E9DJeNoc
  const findMessageForCart = (cartIds, messages) => {
    // Sort messages by priority (ascending)
    const sortedMessages = messages.sort((a, b) => a.priority - b.priority);
    const cartItemIds = cartIds.map(id => Number(id));
    let returnMessage;

  
    // Find the message object based on product id combinations in the cart
    const messageObject = sortedMessages.find(msg =>
      msg.productIds.every(id => cartItemIds.includes(id))
    );
  
    // Add the found message to the cartContent object
    if (messageObject) {
      returnMessage = messageObject;
    }
  
    return returnMessage;
  };

  // const findProductId = (el) => {
    
  //   // Regular expression to match the ID part
  //   const regex = /product-id-(\d+)/;
    
  //   // Extract the ID using the regular expression
  //   for (const className of el.classList) {
  //     const match = className.match(regex);
  //     if (match) {
  //       return match[1]; // Return the ID if found
  //     }
  //   }
  //   return null; // Return null if no ID found
  // };

  //rebuy upsell add - found on rebuy app

  // const rebuyButton = document.querySelectorAll('.rebuy-product-actions button');
  
  // rebuyButton.forEach(function(el) {
  //   el.addEventListener('click', function(e) {
  //     const target = e.currentTarget;
  //      console.log(target);
  //      console.log(target.querySelector('span').innerText);
  //     if (target.querySelector('span').innerText == 'ADDING...') {
  //       // Peejay's added code - move to live if approved
  //       if (complimentMessages) {
  //        const cartBody = document.querySelector('.rebuy-cart__flyout-content');
  //         const messageEl = cartBody.querySelectorAll(' .compliment-message');
  //         console.log(messageEl);
  //         const rebuyProdId = findProductId(target.closest('.rebuy-product-block'));
  //         const cartIds = [...document.querySelectorAll('.rebuy-cart__flyout-items li')].map(item => item.dataset.productId);
  //        cartIds.push(rebuyProdId);
  //         console.log(cartIds);
  //         const cartMessage = findMessageForCart(cartIds, complimentMessages);
  //         if (cartMessage) {
  //           if (messageEl.length > 0) {
  //             messageEl.forEach(el => el.remove());
  //           }
  //           setTimeout(()=> {
  //             const messageDiv = document.createElement('div');
  //             messageDiv.classList.add('compliment-message');
  //             messageDiv.textContent = cartMessage.message;
  //             cartBody.prepend(messageDiv);
  //           }, 1500)
  //         }
  //         // setTimeout(() => {
  //         //   const messageEl = document.querySelector('.compliment-message');
  //         //   messageEl.classList.add('remove');
  //         // }, 100)
  //       }
  //     }
  //   });
  // });
  // end code

  
   $(document).ready(function () {
    // Peejay added code  - 7/16/2024 - Cart Messages https://webmedic.app/agent/view/gzl2E9DJeNoc
    $(document).on('click', '.rebuy-cart__flyout-item-remove', function(e) {
      if ($('.rebuy-cart__flyout-items li').length <= 1) {
        setTimeout(() => {
          $('.compliment-message').remove(); 
        }, 1500);
      }
      const target = e.currentTarget;
      if (complimentMessages) {
        const cartBody = document.querySelector('.rebuy-cart__flyout-content');
        const messageEl = cartBody.querySelectorAll('.compliment-message');
        const prodToRemoveId = target.closest('.rebuy-cart__flyout-item').dataset.productId;
        const cartIds = [...document.querySelectorAll('.rebuy-cart__flyout-items li')].map(item => item.dataset.productId);
        const newCartIds = cartIds.filter(id => id !== prodToRemoveId);
        console.log(newCartIds);
        const cartMessage = findMessageForCart(newCartIds, complimentMessages);
        console.log(cartMessage);
        if (cartMessage) {
          if (messageEl.length > 0) {
            messageEl.forEach(el => el.remove());
          }
          setTimeout(()=> {
            const messageDiv = document.createElement('div');
            messageDiv.classList.add('compliment-message');
            messageDiv.textContent = cartMessage.message;
            cartBody.prepend(messageDiv);
          }, 1500)
        } else {
          if (messageEl.length > 0) {
            messageEl.forEach(el => el.remove());
          }
        }
        // setTimeout(() => {
        //   const messageEl = document.querySelector('.compliment-message');
        //   messageEl.classList.add('remove');
        // }, 100)
      }
    });
    // end added code
  });
}());
// end added code


// Peejay added code  - move to live once approved - Cart Button https://webmedic.app/agent/view/nYSw4ofl4lFD
document.addEventListener('variant:changed', function(event) {
  console.log('trigger variant:changed event');
  var price = $('.product-sticky-form__price').html();
  var stickyPrice = $('.button-sticky-form__price').html();
  var priceHtml = `Add to cart 
    <span class="atc-text">
      <span class="product-button-price">
      ${price}
      </span>
    </span>
    <span class="guarantee">
      
      30-DAY MONEY BACK GUARANTEE
    </span>
  `;
  $('#StickyAddToCart .loader-button__text').html(priceHtml)
  $('#AddToCart .loader-button__text').html(priceHtml);
});
// end code
if($('.container .page-header .page-header__text-wrapper .heading.h1').text() == "all") {
    $('.container .page-header .page-header__text-wrapper .heading.h1').text('Products')
}

(function() {
  // Peejay added code  - move to live once approved - Cart Button https://webmedic.app/agent/view/nYSw4ofl4lFD
//  function extractCurrency(price) {
//   const regex = /[^\d\s]+(?=\d+(\.\d{1,2})?)/g;
//   const matches = price.match(regex);
  
//   if (!matches || matches.length === 0) {
//     // Handle error: either return a default value or throw an error
//     console.error("Currency not found in the provided price string.");
//     return '';  // or return a default currency symbol if needed (e.g., "$")
//   }
  
//   return matches[0];
// }

  
//   function extractPrice(price) {
//     const regex = /\d+(\.\d{1,2})?/g;
//     const matches = price.match(regex);
    
//     // Check if matches exist and if the first element is valid
//     if (matches && matches.length > 0) {
//       const parsedPrice = parseFloat(matches[0]);
      
//       // Check if parsedPrice is a valid number
//       if (!isNaN(parsedPrice)) {
//         return parsedPrice;
//       } else {
//         console.error("Error: Unable to parse price from matches.");
//         return null; // or throw an error, or return a default value
//       }
//     } else {
//       console.error("Error: No valid price found in the input.");
//       return null; // or throw an error, or return a default value
//     }
//   }

  
//   function changeProdBtnPrice(price, currency) {
//     const productBtnPrice = $('.product-button-price, .product-button-price-shaver');
//     productBtnPrice.each(function () {
//       $(this).html(`${currency}${(price).toFixed(2)}`);
//     });
//   }
  
//   function changePriceList(list, { full, salePrice, addonPrice, save }) {
//     const priceCom = list.find('.price--compare');
//     const price = list.find('.price--highlight');
//     const saleBadge = list.find('.sale-badge');
//     const currency = extractCurrency(price.text());
  
//     priceCom.text(full);
//     price.text(salePrice);
//     saleBadge.text(`SAVE ${currency}${save}`);
//   }
  // end code
  
  // Peejay added code  - move to live once approved - Cart Messages https://webmedic.app/agent/view/gzl2E9DJeNoc
  const findMessageForCart = (cartIds, messages) => {
    // Sort messages by priority (ascending)
    const sortedMessages = messages.sort((a, b) => a.priority - b.priority);
    const cartItemIds = cartIds.map(id => Number(id));
    let returnMessage;

  
    // Find the message object based on product id combinations in the cart
    const messageObject = sortedMessages.find(msg =>
      msg.productIds.every(id => cartItemIds.includes(id))
    );
  
    // Add the found message to the cartContent object
    if (messageObject) {
      returnMessage = messageObject;
    }
  
    return returnMessage;
  };

  // const findProductId = (el) => {
    
  //   // Regular expression to match the ID part
  //   const regex = /product-id-(\d+)/;
    
  //   // Extract the ID using the regular expression
  //   for (const className of el.classList) {
  //     const match = className.match(regex);
  //     if (match) {
  //       return match[1]; // Return the ID if found
  //     }
  //   }
  //   return null; // Return null if no ID found
  // };

  //rebuy upsell add - found on rebuy app

  // const rebuyButton = document.querySelectorAll('.rebuy-product-actions button');
  
  // rebuyButton.forEach(function(el) {
  //   el.addEventListener('click', function(e) {
  //     const target = e.currentTarget;
  //      console.log(target);
  //      console.log(target.querySelector('span').innerText);
  //     if (target.querySelector('span').innerText == 'ADDING...') {
  //       // Peejay's added code - move to live if approved
  //       if (complimentMessages) {
  //        const cartBody = document.querySelector('.rebuy-cart__flyout-content');
  //         const messageEl = cartBody.querySelectorAll(' .compliment-message');
  //         console.log(messageEl);
  //         const rebuyProdId = findProductId(target.closest('.rebuy-product-block'));
  //         const cartIds = [...document.querySelectorAll('.rebuy-cart__flyout-items li')].map(item => item.dataset.productId);
  //        cartIds.push(rebuyProdId);
  //         console.log(cartIds);
  //         const cartMessage = findMessageForCart(cartIds, complimentMessages);
  //         if (cartMessage) {
  //           if (messageEl.length > 0) {
  //             messageEl.forEach(el => el.remove());
  //           }
  //           setTimeout(()=> {
  //             const messageDiv = document.createElement('div');
  //             messageDiv.classList.add('compliment-message');
  //             messageDiv.textContent = cartMessage.message;
  //             cartBody.prepend(messageDiv);
  //           }, 1500)
  //         }
  //         // setTimeout(() => {
  //         //   const messageEl = document.querySelector('.compliment-message');
  //         //   messageEl.classList.add('remove');
  //         // }, 100)
  //       }
  //     }
  //   });
  // });
  // end code

  
   $(document).ready(function () {
    // Peejay added code  - move to live once approved - Cart Button https://webmedic.app/agent/view/nYSw4ofl4lFD
    // $(document).on('click','.kaching-bundles__bar', function(e) {
    //   // $('#AddToCart .button-sticky-form__price').remove();
    //   const target = $(e.currentTarget);
    //   const parent = target.parents('.product__info');
    //   const priceList = $('[data-product-price-list]');
    //   const addonCheckBox = parent.find('.lb-spc-details-checkbox');
    //   const isAddonChecked = addonCheckBox.is(':checked');
    //   // addonCheckBox.prop('checked', false);
    //   // addonCheckBox.attr('checked', false);
    //   const addonPrice = extractPrice(parent.find('.money').text());
      
    //   const bundlePriceObj = {
    //     full: target.find('.kaching-bundles__bar-full-price').text(),
    //     salePrice: target.find('.kaching-bundles__bar-price').text(),
    //   };
    //   bundlePriceObj.save = extractPrice(bundlePriceObj.full) - extractPrice(bundlePriceObj.salePrice);
    //   const currency = extractCurrency(bundlePriceObj.full);
    
    //   // ATOME installments (below pricing)
    //   const atomePrice = parent.find('#atome-price');
    //   const atomeParent = atomePrice.parent();
    //   atomePrice.hide();
    //   atomePrice.parent().html(`or 3 payments of <span id="atome-price" style="color: rgb(13, 20, 56); font-weight: bold; font-size: inherit; display: none;"></span><span id="atome-prices" style="color: rgb(13, 20, 56); font-weight: bold; font-size: inherit; ">${currency}${Math.round((extractPrice(bundlePriceObj.full) / 3) + Number.EPSILON) * 100 / 100}</span> with `);
      
    //   // change Price list when bundle
    //   changePriceList(priceList, bundlePriceObj);
    
    //   // change Add to cart and sticky atc buttons
    //   const salePrice = extractPrice(bundlePriceObj.salePrice);
    //   const totalPrice = isAddonChecked && addonPrice ? salePrice + addonPrice : salePrice;
    //   setTimeout(() => {
    //     changeProdBtnPrice(totalPrice, currency);
    //   }, 0);
    // });
    
    // $(document).on('click', '.lb-spc-details-checkbox', function(e) {
    //   const target = $(e.target); 
    //   const parent = target.parents('.product__info');
    //   const addonPrice = parent.find('.lb-spc-details-sale-price .money').text();
    //   const bundleSelected = parent.find('.kaching-bundles__bar input[name*="kaching-bundles-deal"]:checked');
    //   const currentPriceText = bundleSelected.parent().find('.kaching-bundles__bar-price').text();
      
    //   const currency = extractCurrency(addonPrice);
    //   const currentPrice = extractPrice(currentPriceText);
    //   const addPrice = extractPrice(addonPrice);
      
    //   const totalPrice = target.is(':checked') && addonPrice ? currentPrice + addPrice : currentPrice;
    //   setTimeout(() => {
    //     changeProdBtnPrice(totalPrice, currency);
    //   }, 0);
    // });
    // end code
    // Peejay added code  - move to live once approved - Cart Messages https://webmedic.app/agent/view/gzl2E9DJeNoc
    $(document).on('click', '.rebuy-cart__flyout-item-remove', function(e) {
      if ($('.rebuy-cart__flyout-items li').length <= 1) {
        setTimeout(() => {
          $('.compliment-message').remove(); 
        }, 1500);
      }
      const target = e.currentTarget;
      if (complimentMessages) {
        const cartBody = document.querySelector('.rebuy-cart__flyout-content');
        const messageEl = cartBody.querySelectorAll('.compliment-message');
        const prodToRemoveId = target.closest('.rebuy-cart__flyout-item').dataset.productId;
        const cartIds = [...document.querySelectorAll('.rebuy-cart__flyout-items li')].map(item => item.dataset.productId);
        const newCartIds = cartIds.filter(id => id !== prodToRemoveId);
        console.log(newCartIds);
        const cartMessage = findMessageForCart(newCartIds, complimentMessages);
        console.log(cartMessage);
        if (cartMessage) {
          if (messageEl.length > 0) {
            messageEl.forEach(el => el.remove());
          }
          setTimeout(()=> {
            const messageDiv = document.createElement('div');
            messageDiv.classList.add('compliment-message');
            messageDiv.textContent = cartMessage.message;
            cartBody.prepend(messageDiv);
          }, 1500)
        } else {
          if (messageEl.length > 0) {
            messageEl.forEach(el => el.remove());
          }
        }
        // setTimeout(() => {
        //   const messageEl = document.querySelector('.compliment-message');
        //   messageEl.classList.add('remove');
        // }, 100)
      }
    });
    // end added code
  });
}());
// end added code
/*
/*
$(document).ready(function() {
  var rating = $('#judgeme_product_reviews .jdgm-rev-widg').attr('data-average-rating');
  $('.jdgm-rev-widg__summary').prepend('<div class="rating">' + rating + '</div>')

  
  $('.read-more-container').wrapInner('<div class="read-more-inner" style="display: none;"></span>')
  $('.read-more-container').append('<span class="read-more">Read More</span>');
  
  
  $(".read-more").on("click", function () {
    var inner = $(this).closest('.read-more-container').find('.read-more-inner');
    var txt = inner.is(':visible') ? 'Read More' : 'Read Less';
    $(this).text(txt);
    inner.slideToggle(200);
  });

});
*/

$(document).ready(function() {
  var rating = $('#judgeme_product_reviews .jdgm-rev-widg').attr('data-average-rating');
  $('.jdgm-rev-widg__summary').prepend('<div class="rating">' + rating + '</div>')

  
  // $('.read-more-container').wrapInner('<div class="read-more-inner" style="display: none;"></span>')
  // $('.read-more-container').append('<span class="read-more">Read More</span>');
  // $('.read-more-inner').css('display', 'none');
  
  $(".read-more").on("click", function (e) {
    var inner = $(this).parent().find('.read-more-inner');
    var txt = inner.is(':visible') ? 'Read More' : 'Read Less';
    console.log("INNER: ", inner);
    $(this).text(txt);
    inner.slideToggle(200);
  });

  /*
  $(window).scroll(function(e) {
      console.log(e.currentTarget.scrollY);
      var top = e.currentTarget.scrollY;
      var galHeight = $('#lightGallery').height();
  
      $('.product__info').each(function(e) {
          var infoHeight = $(this).height();
          var con = galHeight - infoHeight;
          
          if (top <= con) {
              $('.product__info').css('transform', 'translateY('+top+'px)');
          }
      })
  });
  */
  var flag = false;
  setInterval(() => {
    var label = $('lb-upsell-product-page-addon lb-product-card .lb-spc-details-cont .lb-spc-details-name');
    
    if (label.length > 0 && !flag) {
      label.each(function(i, val) {
          var text = $(val).text();
          $(val).text("Add " + text);
      })
      flag = true;
    }
  }, 1000)
  
if ($.fn.lightGallery && $("#lightGallery").length) {
    $("#lightGallery").lightGallery();
}
});

jQuery(function($){
   $( document ).ready(function(){
        $('.pop-ship').magnificPopup({
            type: 'inline',
            preloader: false,
            modal: true
        });
        $(document).on('click', '.popup-modal-dismiss', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
   });
});

// Function to update the cart button price when checkbox is checked or unchecked

jQuery(document).ready(function(){
  console.log('color swatch 1');  
  jQuery(".color-swatch").each(function(){
    console.log('color swatch 2');  
    var color_swatch = jQuery(this).children('label');
    var color_url=jQuery(this).attr('image-url');
     var color_value=jQuery(this).siblings("input.color-swatch__radio").val();
    color_swatch.click(function(){      
 
       if ($(window).width() <= 768) {
           
         console.log('color_url', color_url);  
             jQuery('.gallery_load_more').hide();
            jQuery('.product__thumbnail-item').each(function(){
              var image_name=jQuery(this).children('.product__thumbnail').children('img').attr('src');
              if (image_name.includes(color_url)) {
                jQuery(this).click();                
              }
          });
       } else {
        
         var color_value_val = jQuery(this).parent().find("input.color-swatch__radio").val();
         jQuery('.variant-image').removeClass('active');
      jQuery('.variant-image').each(function(){
          var image_variant=jQuery(this).data('variant');
          var image_name=jQuery(this).children('img').attr('src');
        
          if ((image_variant.includes(color_value_val))||(image_name.includes(color_value_val))) {
            jQuery(this).addClass('active');
            jQuery('.gallery_load_more').hide();
          }
      });
      console.log('color_value_desktop', color_value_val);  
       }
    });
  });

  jQuery('.gallery_load_more').click(function(){
    jQuery('.variant-image').removeClass('active');
    jQuery('.variant-image').addClass('active');
    jQuery(this).hide();
  });

  
      
});

(function () {

  function parsePrice(text) {
    if (!text) return 0;
    return parseFloat(text.replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
  }

  function getBundlePrice() {
    const selected = document.querySelector('.kaching-bundles__bar--selected');
    if (!selected) return 0;

    const priceEl = selected.querySelector('.kaching-bundles__bar-price');
    return priceEl ? parsePrice(priceEl.textContent) : 0;
  }

  // ✅ FIXED UPSELL LOGIC (based on your real HTML)
  function getUpsellTotal() {
    let total = 0;

    const addon = document.querySelector('lb-upsell-product-page-addon');
    if (!addon) return 0;

    const cards = addon.querySelectorAll('.lb-upsell-product-page-card');

    cards.forEach(card => {
      const checkbox = card.querySelector('.lb-spc-details-checkbox');
      const priceEl = card.querySelector('.lb-upsell-money-2');

      if (checkbox && checkbox.checked && priceEl) {
        total += parsePrice(priceEl.textContent);
      }
    });

    return total;
  }

  function updateMainPrice() {
    const priceContainer = document.querySelector('.product-meta__price-list-container .price');
    if (!priceContainer) return;

    const bundle = getBundlePrice();
    const upsell = getUpsellTotal();

    const total = bundle + upsell;

    const formatted = "$" + total.toFixed(2) + " SGD";

    const mainMoney =
      priceContainer.querySelector('.price-item--regular .money') ||
      priceContainer.querySelector('.money') ||
      priceContainer;

    mainMoney.textContent = formatted;
  }

  // 🔥 lightweight polling (reliable for blocked events)
  function startWatcher() {
    updateMainPrice();

    setInterval(() => {
      updateMainPrice();
    }, 300); // lightweight, no freeze
  }

  function waitForElements() {
    const price = document.querySelector('.product-meta__price-list-container .price');
    const kaching = document.querySelector('.kaching-bundles__bar');
    const upsell = document.querySelector('lb-upsell-product-page-addon');

    if (price && kaching && upsell) {
      startWatcher();
    } else {
      setTimeout(waitForElements, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForElements);
  } else {
    waitForElements();
  }

})();